export default {
	name: "upload-bol-modal",
	props: ["orderId", "showModal", "modalId"],
	emits: ["closeModal"],
	data() {
		return {
			bol: null,
			modalComponentId: null,
			modalHeading: null,
			loading: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
		};
	},
	methods: {
		onModalCloseClick(){
			this.$emit("closeModal");
		},
		onBolAttach(event){
			this.bol = event.target.files[0];
		},
		clearMessageAlerts(){
			this.showSuccessMessage = false;
			this.successMessage = null;
			this.showErrorMessage = false;
			this.errorMessage = null;
			this.$emit("closeModal");
		},
		onModalSaveClick(){
			this.loading = true;
			var formData = new FormData();
			formData.append("orderId", this.orderId);
			formData.append("bol", this.bol);
			exTankService.markOrderExTankAsUplifted(formData).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.showSuccessMessage = true;
						this.successMessage = "BOL uploaded successfully.";
					}
					else{
						this.showErrorMessage = true;
						this.errorMessage = "Error uploading BOL";
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		}
	},
	mounted: function () {
		
	},
	watch: {
		orderId:{
			handler: function () {
				if (this.order !== null && this.orderId > 0) {
					this.modalHeading = "Upload BOL for order #" + this.orderId;
				}
			},
			immediate: true,
			deep: true
		},
		modalId: {
			handler: function () {
				if (this.modalId) {
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal: {
			handler: function () {
				if (this.showModal) {
					$("#" + this.modalComponentId).modal({
						keyboard: false,
						backdrop: 'static',
						show: true
					});
				} else {
					$("#" + this.modalComponentId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
	}
};